import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IListMailboxRequest extends IBaseRequest {
    treeHandle?: string;
    domainId?: number;
    userId?: number;
    usableByUser?: number;
    offset?: number;
    limit?: number;
}

export class ListMailboxRequest extends BaseRequest implements IListMailboxRequest {
    public treeHandle?: string;
    public domainId?: number;
    public userId?: number;
    public usableByUser?: number;
    public offset?: number;
    public limit?: number;

  constructor(server: string, session: string, otherOptions?: any) {
    super(server, session);
    this.treeHandle = otherOptions.treeHandle;
    this.domainId = otherOptions.domainId;
    this.userId = otherOptions.userId;
    this.usableByUser = otherOptions.usableByUser;
    this.offset = otherOptions.offset;
    this.limit = otherOptions.limit;
  }

  public toXml(): string {
    var parameters: string = super.toXml();

    parameters += this.makeNode(this.treeHandle, 'treeHandle');
    parameters += this.makeNode(this.domainId, 'domainId');
    parameters += this.makeNode(this.userId, 'userId');
    parameters += this.makeNode(this.usableByUser, 'usableByUser');
    parameters += this.makeNode(this.offset, 'offset');
    parameters += this.makeNode(this.limit, 'limit');

    return super.wrapperXml('ListMailbox', parameters);
  }
}
